module.exports = __webpack_public_path__ + "static/cx-mobile-screen2-a13f843cfc179cc003e3d0c8a5de0c96.jpeg";